import React from 'react';
import {
  IonCard,
  IonCardHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonSpinner,
} from '@ionic/react';
import { arrowBack, mail } from 'ionicons/icons';
import { AuthInput } from './AuthComponents';
import styles from '../../pages/login/LoginReg.module.scss';
import { useTranslation } from 'react-i18next';

interface ResetCardProps {
  formData: {
    email: string;
  };
  isDisabled: boolean;
  hasValidEmail: boolean;
  onGoBack: () => void;
  onReset: () => void;
  onInputChange: (field: string, value: string) => void;
}

export const ResetCard: React.FC<ResetCardProps> = ({
  formData,
  isDisabled,
  hasValidEmail,
  onGoBack,
  onReset,
  onInputChange
}) => {
  const { t } = useTranslation();
  return (
  <IonCard className={`${styles.loginCard} ion-text-center`}>
    <IonCardHeader className={styles.cardHeader}>
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton
            fill="clear"
            className={styles.backButton}
            onClick={onGoBack}
            disabled={isDisabled}
          >
            <IonIcon icon={arrowBack} />
          </IonButton>
        </IonButtons>
        <IonTitle className={styles.cardTitle}>{t('components.AuthComponents.ResetCard.resetPassword')}</IonTitle>
      </IonToolbar>
    </IonCardHeader>
    <IonGrid>
      <IonRow>
        <IonCol>
          <form onSubmit={(e) => { e.preventDefault(); onReset(); }}>
            <IonText className={styles.resetText}>
              <p>{t('components.AuthComponents.ResetCard.enterYourEmailToReceiveA')}</p>
            </IonText>
            <AuthInput
              label={t('components.AuthComponents.ResetCard.email')}
              type="email"
              placeholder="email@domain.com"
              value={formData.email}
              onInput={(value) => onInputChange('email', value)}
              icon={mail}
              disabled={isDisabled}
              required
              className={styles.customInput}
            />
            <IonRow className="ion-justify-content-center">
              <IonCol size="auto">
                <IonButton
                  expand="block"
                  className={`ion-margin-top ion-margin-bottom ${styles.customButton} ${styles.mainButton}`}
                  type="submit"
                  disabled={isDisabled || !hasValidEmail}
                >
                  {isDisabled ? <IonSpinner name="dots" /> : t('components.AuthComponents.ResetCard.resetPassword')}
                </IonButton>
              </IonCol>
            </IonRow>
          </form>
        </IonCol>
      </IonRow>
    </IonGrid>
  </IonCard>
);
};
